import React from 'react';
import {
  Box,
  Typography,
  Divider,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useContext, useEffect } from 'react';
import {
  BabysitterContext,
  BabysitterContextProps,
} from '../../../context/BabysitterContext';
import RightArrow from '../../../assets/RightArrow.svg';
import { Pagination } from '@mui/material';
import NotificationwhiteIcon from '../../../assets/NotoficationIcon.svg';
import StyledBgContainer from '../../../components/StyledBgContainer/StyledBgContainer';
import moment from 'moment-timezone';
import LeftArrow from '../../../assets/Left 1.svg';
import { useNavigate } from 'react-router-dom';
import { markNotificationAsRead } from '../../../services/NetworkServices';
import { useWebSocket } from '../../../context/WebSocketContext';
import { getStage } from '../../../services/NetworkServices';
import { storeStageNumber } from '../../../utils/auth-token-utils/cookie';
import TopNav from '../../../components/TopNav/TopNav';
import DataUnavailable from '../../../components/DataUnavailable';

const NotificationsList = () => {
  const {
    setCurrentPage,
    totalRecords,
    itemsPerPage,
    currentPage,
    handleNextPage,
    handlePreviousPage,
    notificationsList,
    handleNotificationsList,
    markAsRead,
    handleMarkAsRead,
  } = useContext(BabysitterContext) as BabysitterContextProps;
  const { socket } = useWebSocket();
  console.log('notificationsList in line 12 ', notificationsList);

  const formatNotificationDate = (date: any) => {
    const notificationDate = moment(date); // Create a moment object from the notification date
    const today = moment(); // Get today's date
    const yesterday = moment().subtract(1, 'days'); // Get yesterday's date

    if (notificationDate.isSame(today, 'day')) {
      return ''; // If it's today, return an empty string
    } else if (notificationDate.isSame(yesterday, 'day')) {
      return 'Yesterday'; // If it's yesterday, return "yesterday"
    } else {
      return notificationDate.format('DD|MM|YYYY'); // Otherwise, format it as DD|MM|YYYY
    }
  };
  const navigate = useNavigate();
  const handleNotificationBackClick = async () => {
    const response = await markNotificationAsRead();
    const data = await response.data;
    if (data) {
      handleMarkAsRead(!markAsRead);
      navigate('/supervisor/dashboard');
    }
  };

  const formatTime = (utcTime: any) => {
    const updatedAt = moment.utc(utcTime).tz('America/New_York');
    const isToday = updatedAt.isSame(moment(), 'day');

    // Format the time for display
    const displayTime = isToday
      ? updatedAt.fromNow()
      : updatedAt.format('hh:mm A');
    return displayTime;
  };

  // useEffect(() => {
  //   socket?.on("group-message-notification", (data) => {
  //     console.log("group-message-notification", data);
  //     handleNotificationsList([...notificationsList, data]);
  //   });
  // }, [socket]);
  const formatNotification = (data: any): any => {
    return {
      createdAt: new Date().toISOString(),
      message: data.message,
      notificationType: data.notificationType || data.type, // Ensure correct key for type
      read: false,
      updatedAt: new Date().toISOString(),
      userFrom: data.userFrom || null,
      userTo: data.userTo || null,
      _id: data._id || generateUniqueId(), // Generate a unique ID if not provided
    };
  };

  // Utility function to generate a unique ID if none is provided
  const generateUniqueId = () => {
    return '_' + Math.random().toString(36).substr(2, 9);
  };

  useEffect(() => {
    const fetchStageDetails = async () => {
      try {
        const response = await getStage();
        const data = await response.data;
        if (data) {
          const stage = data.data.stage;
          storeStageNumber(stage);
          if (stage === '1') {
            navigate('/supervisor/createProfile');
          }
        }
      } catch (error) {
        console.error('Error fetching profile details:', error);
      }
    };
    fetchStageDetails();
  }, [navigate]);

  // Utility function to generate a unique ID if none is provided
  useEffect(() => {
    const handleNotification = (data: any) => {
      console.log('notification received', data);

      const todayDate = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format

      const newNotification = formatNotification(data); // Format the notification

      // Create a copy of the current list
      const updatedList = [...notificationsList]; // You might need to replace this with how you are managing the list

      // Find if today's date already exists in the list
      const existingDateIndex = updatedList.findIndex(
        (item) => item.date === todayDate,
      );

      if (existingDateIndex !== -1) {
        // If today's date exists, unshift the new notification to the start of the notifications array
        updatedList[existingDateIndex].notifications.unshift(newNotification);
      } else {
        // If today's date doesn't exist, create a new entry at the beginning
        updatedList.unshift({
          date: todayDate,
          notifications: [newNotification],
        });
      }

      // Pass the updated list to handleNotificationsList
      handleNotificationsList(updatedList);
    };

    socket?.on('group-message-notification', handleNotification);
    socket?.on('face-auth-success-notification', handleNotification);
    socket?.on('face-auth-fail-notification', handleNotification);
    socket?.on('broadcast-notification', handleNotification);

    // Cleanup socket listeners on unmount
    return () => {
      socket?.off('group-message-notification', handleNotification);
      socket?.off('face-auth-success-notification', handleNotification);
      socket?.off('face-auth-fail-notification', handleNotification);
      socket?.off('broadcast-notification', handleNotification);
    };
  }, [socket, notificationsList]);

  return (
    <StyledBgContainer>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '24px 24px',
          color: 'white',
          position: 'relative',
        }}
      >
        {/* Back Arrow */}
        <img
          src={LeftArrow}
          className="group-chat-list-back-icon"
          onClick={handleNotificationBackClick}
        />

        {/* Centered Title */}
        <Typography
          variant="h6"
          sx={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            fontWeight: 'bold',
          }}
        >
          Notifications
        </Typography>

        {/* Empty box for right side spacing */}
        <Box sx={{ width: '40px' }} />
      </Box>

      <Box
        sx={{
          background: '#606F8C26',
          borderRadius: '16px', // Rounded corners
          padding: '50px', // Padding inside the box
          width: '100%', // Full width
          maxWidth: '1200px', // Maximum width
          margin: 'auto', // Center the box horizontally
          color: 'white', // White text color
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)', // Subtle shadow for depth
          maxHeight: '400px', // Fixed max height for the content
          overflowY: 'scroll', // Enable scrolling
          position: 'relative', // Positioning for proper layering
          zIndex: 1, // Ensure layering above background
          top: '50px',

          /* Hide scrollbar */
          scrollbarWidth: 'none', // For Firefox
          '&::-webkit-scrollbar': {
            display: 'none', // For Chrome, Safari, and Edge
          },
        }}
      >
        {notificationsList.map((notification, index) => (
          <Box
            key={index}
            sx={{
              paddingBottom: '20px', // Padding to space out each group
              textAlign: 'left',
            }}
          >
            <Typography
              variant="body2"
              sx={{ marginBottom: '16px', color: '#FFFFFFA6' }}
            >
              {formatNotificationDate(notification.date)}
            </Typography>

            {notification && notification.notifications.length > 0 ? (
              notification.notifications.map(
                (eachNotification: any, idx: number) => (
                  <Box
                    key={idx}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '16px 0', // Padding to space out each notification
                      borderBottom:
                        idx !== notification.notifications.length - 1
                          ? '1px solid rgba(255, 255, 255, 0.1)'
                          : 'none', // White border between notifications
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src={NotificationwhiteIcon}
                        style={{
                          width: '30px',
                          height: '30px',
                          marginRight: '10px',
                        }} // Adjusted size and margin for icon
                        alt="Notification"
                      />
                      <Typography variant="body2">
                        {eachNotification?.message}
                      </Typography>
                    </Box>

                    <Typography variant="caption" sx={{ color: '#FFFFFFA6' }}>
                      {formatTime(eachNotification.createdAt)}
                    </Typography>
                  </Box>
                ),
              )
            ) : (
              <DataUnavailable description="No record found" />
            )}
          </Box>
        ))}

        {totalRecords > 5 && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingTop: '20px',
              flexWrap: 'wrap', // Allow wrapping for smaller screens
            }}
          >
            {/* Previous Button */}
            <Box
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                marginBottom: { xs: '10px', sm: '0' }, // Margin adjustment for small screens
              }}
              onClick={() => handlePreviousPage(currentPage - 1)}
            >
              <img
                src={LeftArrow}
                alt="Previous"
                style={{ marginRight: '8px' }}
              />
              <Typography variant="body2">Previous</Typography>
            </Box>

            {/* Pagination */}
            <Pagination
              count={Math.ceil(totalRecords / itemsPerPage)}
              page={currentPage}
              onChange={(e, value) => setCurrentPage(value)}
              color="primary"
              sx={{
                display: { xs: 'block', sm: 'inline-flex' }, // Stack on small screens, inline on larger
                '& .MuiPaginationItem-root': {
                  color: '#FFFFFF66',
                },
                '& .Mui-selected': {
                  color: 'white',
                },
                marginBottom: { xs: '10px', sm: '0' }, // Margin for smaller screens
              }}
            />

            {/* Next Button */}
            <Box
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
              onClick={() => handleNextPage(currentPage + 1)}
            >
              <Typography variant="body2" sx={{ marginRight: '8px' }}>
                Next
              </Typography>
              <img src={RightArrow} alt="Next" />
            </Box>
          </Box>
        )}
      </Box>
    </StyledBgContainer>
  );
};

export default NotificationsList;
